import { ShieldAlert } from 'lucide-react';
import { useMemo } from 'react';
import { Navigate, useParams } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageHeader } from '../../../shared/components/PageHeader';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { withinSection } from '../../../shared/components/section-trail';
import { SuggestionsPicker } from '../components/SuggestionsPicker';
import { useAssignmentSuggestions } from '../hooks/use-assignment-suggestions';
import { useBlockedCandidates } from '../hooks/use-blocked-candidates';
import { useChooseCrew } from '../hooks/use-choose-crew';
import { defaultSuggestionWindow } from '../policies/suggestion-window.policy';

/** The crews to offer a trip, best first, with the reasons; choosing one assigns it (gitaumoses4/chukua#52). */
export function AssignTripPage() {
  const { id = '' } = useParams();
  const window = useMemo(() => defaultSuggestionWindow(new Date()), []);
  const { state, list, isRefreshing } = useAssignmentSuggestions(id, window);
  const eligibility = useBlockedCandidates(id, window);
  const { choose, chosenRank } = useChooseCrew(id, window);

  if (state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      <PageHeader
        breadcrumbs={withinSection('dispatch')}
        title="Suggested crews"
        description="Trucks, trailers and drivers that could take this trip over the next 24 hours, best first, and the ones that cannot, with why."
      />
      {state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load the suggestions" description="Something went wrong loading this list. Try reloading the page." />
      )}
      {state.status === 'not-available' && <EmptyState icon={ShieldAlert} title="No suggestions for this trip" description={state.message} />}
      {state.status === 'loading' && <TableSkeleton label="Loading suggestions" withSearch />}
      {state.status === 'loaded' && (
        <SuggestionsPicker page={state.page} list={list} eligibility={eligibility} isRefreshing={isRefreshing} chosenRank={chosenRank} onChoose={choose} />
      )}
    </>
  );
}
